<template>
  <!-- 閾値についてのヘルプダイアログ -->
  <v-dialog 
    width="700px" 
    v-model="showThresholdHelpDialog" 
  >
    <v-card>
      <v-toolbar >
        <v-toolbar-title v-if="selectEditServiceId==1" > {{$t('service.flow-and-time')}} </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==2" > {{$t('service.ro-membrane')}}  </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==3" > {{$t('service.temperature')}}  </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==5 && validationType==0" > {{$t('service.pressure')}}  </v-toolbar-title>
        <v-toolbar-title v-if="selectEditServiceId==5 && validationType==1" > {{$t('watersystem.differential-pressure')}}  </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showThresholdHelpDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text v-if="selectEditServiceId==1" class="help-dialog-text" >{{$t('watersystem.about-flow-and-time-text')}} </v-card-text>
      <v-card-text v-if="selectEditServiceId==2" class="help-dialog-text" >{{$t('watersystem.about-ro-membrane-text')}} </v-card-text>
      <v-card-text v-if="selectEditServiceId==3" class="help-dialog-text" >{{$t('watersystem.about-temperature-text')}} </v-card-text>
      <v-card-text v-if="selectEditServiceId==5 && validationType==0" class="help-dialog-text" >{{$t('watersystem.about-pressure-text')}} </v-card-text>
      <v-card-text v-if="selectEditServiceId==5 && validationType==1" class="help-dialog-text" >{{$t('watersystem.about-differential-pressure-text')}} </v-card-text>
      <div>
      <h4 class="help-dialog-header" >■{{$t('watersystem.need-sensor')}}</h4>
        <v-card-text v-if="selectEditServiceId==1" >{{$t('sensor.flow')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==2" >{{$t('sensor.tds')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==3" >{{$t('sensor.temperature')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==5 && validationType==0" >{{$t('sensor.pressure')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==5 && validationType==1" >{{$t('watersystem.differential-pressure-need-sensor')}}</v-card-text>
      </div>
      <div>
      <h4 class="help-dialog-header"  >■{{$t('watersystem.about-threshold-setting')}}</h4>
        <v-card-text v-if="selectEditServiceId==1" >{{$t('watersystem.about-setting-flow-and-time-text').replace('[UNIT]', this.unit)}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==2" >{{$t('watersystem.about-setting-ro-membrane-text')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==3" >{{$t('watersystem.about-setting-temperature-text')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==5 && validationType==0" >{{$t('watersystem.about-setting-pressure-text')}}</v-card-text>
        <v-card-text v-if="selectEditServiceId==5 && validationType==1" >{{$t('watersystem.about-setting-differential-pressure-text')}}</v-card-text>
      </div>
      <v-layout  v-if="selectEditServiceId==1"  row wrap>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_blue@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.flow')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_lime@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.time-elapsed')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_alert@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.alert')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_warning@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.warning')}}</v-flex>
        <v-flex xs12 >
          <img class="setting-dialog-threshold-drawing" src="../assets/images/inst_wt@3x.png" alt="" >
        </v-flex>
      </v-layout>
      <v-layout  v-if="selectEditServiceId==2"  row wrap>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_lightblue@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.entrance-impurity-content')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_blue@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.exit-impurity-content')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_alert@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.alert')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_warning@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.warning')}}</v-flex>
        <v-flex xs12 >
          <img class="setting-dialog-threshold-drawing" src="../assets/images/inst_ro@3x.png" alt="" >
        </v-flex>
      </v-layout>
      <v-layout  v-if="selectEditServiceId==3"  row wrap>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_blue@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.temperature-content')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_alert@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.alert')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_warning@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.warning')}}</v-flex>
        <v-flex xs12 >
          <img class="setting-dialog-threshold-drawing" src="../assets/images/inst_tm@3x.png" alt="" >
        </v-flex>
      </v-layout>
      <v-layout  v-if="selectEditServiceId==5"  row wrap>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_line_blue@2x.png" alt="" ></v-flex>
        <v-flex v-if="validationType==0" class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.pressure')}}</v-flex>
        <v-flex v-if="validationType==1" class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.differential-pressure-value')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_alert@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.alert')}}</v-flex>
        <v-flex class="setting-dialog-threshold-div-icon" xs1  ><img class="setting-dialog-threshold-icon" src="../assets/images/icon_bell_warning@2x.png" alt="" ></v-flex>
        <v-flex class="setting-dialog-threshold-icon-title" xs1  >{{$t('watersystem.warning')}}</v-flex>
        <v-flex xs12 >
          <img v-if="validationType==0" class="setting-dialog-threshold-drawing" src="../assets/images/inst_pr@3x.png" alt="" >
          <img v-if="validationType==1" class="setting-dialog-threshold-drawing" src="../assets/images/inst_dp@3x.png" alt="" >
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HelpDialog',
  data () {
    return {
      showThresholdHelpDialog: false,
      unit: this.$store.getters.settingParams.unit,
      selectEditServiceId: 0,
      validationType: 0
    }
  },
  methods: {
    openHelpDialog (params) {
      // 親フォームから呼び出される入り口
      this.setParam(params)
      this.showThresholdHelpDialog = true
    },
    setParam (params) {
      // 親からのパラメータ受け渡し
      this.selectEditServiceId = params.selectEditServiceId
      this.validationType = params.validationType
    }
  }
}
</script>

<style>
.help-dialog-header {
  margin-left:5px;
}
.help-dialog-text {
  background-color: #F2F2F2;
  border-radius:5px;
  margin-right: auto;
  margin-left: auto;
  margin-top:5px;
  margin-bottom:5px;
  width:98%;
}
.setting-dialog-threshold-drawing{
  display:block;
  width:80%;
  margin-left: auto;
  margin-right: auto;
}
.setting-dialog-threshold-icon{
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 0px;
}
.setting-dialog-threshold-icon-title{
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0px;
  margin-right: 10px;
}
.setting-dialog-threshold-div-icon{
  margin-top: auto;
  margin-bottom: auto;
}

</style>



// WEBPACK FOOTER //
// HelpDialog.vue?64a1f37c